// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================ */
/* FILE: VoiceConfirmation.css */
/* ============================================ */

.voice-confirmation-container {
  border-radius: 12px;
  padding: 12px;
  display: flex;
  gap: 20px;
  align-items: flex-start;
  border: 1px solid #8D49CE;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  width: 90%;
}

.voice-confirmation-icon {
  flex-shrink: 0;
}

.mic-icon {
  width: 40px;
  height: 40px;
  color: white;
  stroke-width: 2.5;
}

.voice-confirmation-content {
  flex: 1 1;
}

.voice-confirmation-title {
  font-size: 15px;
  font-weight: 600;
  color: white;
  font-family: var(--font-family-primary);
  margin: 0px;
}

.voice-confirmation-subtitle {
  font-size: 15px;
   font-family: var(--font-family-primary);
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  margin: 0px 0px 10px 0px;
}

.voice-confirmation-credits {
  font-weight: 700;
  color: white;
}

.voice-confirmation-options {
  display: flex;
  gap: 32px;
  align-items: center;
}

.voice-option-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.voice-option-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.voice-radio-button {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2.5px solid rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background-color: transparent;
}

.voice-radio-button.selected {
  border-color: white;
}

.voice-radio-inner {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: transparent;
  transition: all 0.2s ease;
}

.voice-radio-button.selected .voice-radio-inner {
  background-color: white;
}

.voice-option-text {
  font-size: 18px;
  font-weight: 500;
  color: white;
}

/* Hover effects */
.voice-option-label:hover .voice-radio-button {
  border-color: white;
  transform: scale(1.05);
}

@media screen and (min-width: 1440px){
  .voice-confirmation-container {
    width: 70%;
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .voice-confirmation-container {
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .voice-confirmation-title {
    font-size: 18px;
  }

  .voice-confirmation-subtitle {
    font-size: 14px;
  }

  .voice-confirmation-options {
    gap: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VoiceConfimation/VoiceConfirmation.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD,gCAAgC;AAChC,iDAAiD;;AAEjD;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,yCAAyC;EACzC,8EAA8E;EAC9E,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,eAAe;GACd,uCAAuC;EACxC,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":["/* ============================================ */\n/* FILE: VoiceConfirmation.css */\n/* ============================================ */\n\n.voice-confirmation-container {\n  border-radius: 12px;\n  padding: 12px;\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n  border: 1px solid #8D49CE;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  width: 90%;\n}\n\n.voice-confirmation-icon {\n  flex-shrink: 0;\n}\n\n.mic-icon {\n  width: 40px;\n  height: 40px;\n  color: white;\n  stroke-width: 2.5;\n}\n\n.voice-confirmation-content {\n  flex: 1;\n}\n\n.voice-confirmation-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: white;\n  font-family: var(--font-family-primary);\n  margin: 0px;\n}\n\n.voice-confirmation-subtitle {\n  font-size: 15px;\n   font-family: var(--font-family-primary);\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0px 0px 10px 0px;\n}\n\n.voice-confirmation-credits {\n  font-weight: 700;\n  color: white;\n}\n\n.voice-confirmation-options {\n  display: flex;\n  gap: 32px;\n  align-items: center;\n}\n\n.voice-option-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.voice-option-input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.voice-radio-button {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2.5px solid rgba(255, 255, 255, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  background-color: transparent;\n}\n\n.voice-radio-button.selected {\n  border-color: white;\n}\n\n.voice-radio-inner {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background-color: transparent;\n  transition: all 0.2s ease;\n}\n\n.voice-radio-button.selected .voice-radio-inner {\n  background-color: white;\n}\n\n.voice-option-text {\n  font-size: 18px;\n  font-weight: 500;\n  color: white;\n}\n\n/* Hover effects */\n.voice-option-label:hover .voice-radio-button {\n  border-color: white;\n  transform: scale(1.05);\n}\n\n@media screen and (min-width: 1440px){\n  .voice-confirmation-container {\n    width: 70%;\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .voice-confirmation-container {\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n  }\n\n  .voice-confirmation-title {\n    font-size: 18px;\n  }\n\n  .voice-confirmation-subtitle {\n    font-size: 14px;\n  }\n\n  .voice-confirmation-options {\n    gap: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
